import { PermissionStatusEnum } from 'components/routing/enums/userClientPermissionEnum';

import { useGetUserClientsPermission } from './useGetUserClientsPermission';

export const usePermissionToViewOrEdit = (permissionName: string) => {
  const getPermission = useGetUserClientsPermission();
  return getPermission(permissionName) !== PermissionStatusEnum.NONE;
};
